export default __webpack_public_path__ + "static/media/battle-onboarding-contract-01.a14f8dfb.png";